<template functional>
  <button
    class="button-rs"
    :class="props.classes"
    @click="listeners.click"
  >
    <i class="" :class="[props.iconClass, props.icon]"></i>
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    classes: String,
    icon: String,
    iconClass: { type: String, default: 'fab' },
  },
};
</script>
